import { formatDateToISOutc, toLocalMoment } from 'utils';

export const addMs = (date: Date, ms: number) => new Date(date.getTime() + ms);

export const resolveEndOnStartChange = (
  start: Date | null,
  currentEnd: string | null | undefined,
  defaultDuration: number | undefined,
  minDuration: number,
  maxDuration?: number
): string | null => {
  if (!start) {
    return null;
  }

  const minEnd = addMs(start, minDuration);

  if (currentEnd) {
    const currentEndDate = toLocalMoment(currentEnd).toDate();

    if (currentEndDate < minEnd) {
      // currentEnd невалиден — ставим autoEnd только если знаем defaultDuration
      return defaultDuration
        ? formatDateToISOutc(addMs(start, defaultDuration))
        : null;
    }

    if (maxDuration && currentEndDate > addMs(start, maxDuration)) {
      return formatDateToISOutc(addMs(start, maxDuration));
    }

    return currentEnd;
  }

  // end не был задан — автоставим только если передан defaultDuration
  return defaultDuration
    ? formatDateToISOutc(addMs(start, defaultDuration))
    : null;
};

export const resolveEndOnEndChange = (
  end: Date | null,
  start: string | null | undefined,
  minDuration: number,
  maxDuration?: number
): Date | null => {
  if (!end) {
    return null;
  }

  if (!start) {
    return end;
  }

  const startDate = toLocalMoment(start).toDate();
  const minEnd = addMs(startDate, minDuration);

  if (end < minEnd) {
    return minEnd;
  }

  if (maxDuration) {
    const maxEnd = addMs(startDate, maxDuration);

    if (end > maxEnd) {
      return maxEnd;
    }
  }

  return end;
};
